/*
This file is located in the main branch
Last time the file was updated (UTC): [02.07.2024 18:53:01]
Permissions to update outside the main branch: [false]
*/

import { AccordionBody, Button, Draggable, ValidatedInput } from '@finbeat/react-toolkit';
import { faTrashCan } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { t } from 'i18next';
import { QuestionaryInfo } from 'models/api/questionary';
import { QuestionaryItemListProvider } from 'providers/QuestionaryItemListProvider';
import { useState } from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { Trans } from 'react-i18next';
import { Accordion, AccordionHeader, AccordionItem, Row } from 'reactstrap';
import './QuestionaryModal.scss';
import QuestionaryModalQuestionariesBlocks from './QuestionaryModalQuestionariesBlocks';

const emptyPage = {
    id: 0,
    flgVisible: false,
    blocks: [],
};

const QuestionaryModalQuestionaries = () => {
    const [open, setOpen] = useState('');

    const { setFocus } = useFormContext<QuestionaryInfo>();

    const { fields, append, remove, swap } = useFieldArray<QuestionaryInfo>({ name: 'pages' });

    const addPage = () => {
        append(emptyPage, { shouldFocus: true });
        setTimeout(() => setFocus(`pages.${fields.length}.flgVisible`), 1);
    };

    const deletePage = (idx: number) => {
        remove(idx);
    };

    const reorderPages = (source: number, target: number) => {
        swap(source, target);
    };

    const toggle = (id: string) => setOpen((prev) => (prev === id ? '' : id));

    const accordionProps = {
        open: open,
        toggle: toggle,
    };

    return (
        <QuestionaryItemListProvider>
            <div className={`questionary-modal__content`}>
                {
                    <Accordion {...accordionProps}>
                        {fields.map(({ id }, idx) => (
                            <Draggable<number>
                                key={id}
                                typeKey="PAGES"
                                sourceKey={idx}
                                onItemReorder={reorderPages}
                            >
                                <AccordionItem>
                                    <AccordionHeader tag="div" targetId={id}>
                                        <div>
                                            {`${t('BackOfficePage')} ${idx + 1}`}
                                            <FontAwesomeIcon
                                                icon={faTrashCan}
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    deletePage(idx);
                                                }}
                                                className="text-danger"
                                            />
                                        </div>
                                    </AccordionHeader>

                                    <AccordionBody
                                        accordionId={id}
                                        className={`questionary-modal__content`}
                                        toggle={(val) => val && setOpen(val.toString())}
                                    >
                                        <ValidatedInput
                                            type="checkbox"
                                            name={`pages[${idx}].flgVisible`}
                                            label={t('BackOfficeFlgVisible')}
                                        />
                                        <QuestionaryModalQuestionariesBlocks pageIdx={idx} />
                                    </AccordionBody>
                                </AccordionItem>
                            </Draggable>
                        ))}
                    </Accordion>
                }
                <Row>
                    <div className="text-right">
                        <Button outline onClick={addPage}>
                            <Trans i18nKey="BackOfficeAddPage" />
                        </Button>
                    </div>
                </Row>
            </div>
        </QuestionaryItemListProvider>
    );
};

export default QuestionaryModalQuestionaries;
